
import React from 'react';

import { Check } from 'lucide-react';






const Process: React.FC = () => {

return(<section className="py-16 md:py-24 bg-gray-50">
        <div className="container mx-auto px-4 md:px-6">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <span className="inline-block px-3 py-1 rounded-full bg-blue-100 text-blue-600 text-sm font-medium mb-4">
              Our Process
            </span>
            <h2 className="text-2xl md:text-4xl font-bold mb-4 text-gray-900">
              From Idea to Live and Running in 4 Steps
            </h2>
            <p className="md:text-lg text-gray-600">
              Our structured yet flexible approach ensures we deliver a high-quality MVP that validates your concept and delights early users.
            </p>
          </div>
          
          <div className="relative">
            {/* Timeline line */}
            <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-blue-200 hidden md:block"></div>
            
            <div className="space-y-16 relative px-4">
              {/* Step 1 */}
              <div className="flex flex-col md:flex-row items-center">
                <div className="md:w-1/2 md:pr-16 mb-8 md:mb-0 text-center md:text-right">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Discovery Call (Week 1-2)</h3>
                  <p className="text-gray-600">
                    We start by understanding your vision, goals, and constraints. This initial conversation helps us grasp your business model, target users, and technical requirements.
                  </p>
                </div>
                <div className="md:absolute md:left-1/2 md:transform md:-translate-x-1/2 z-10 bg-white rounded-full p-2 border-4 border-blue-500 mb-8 md:mb-0">
                  <div className="w-12 h-12 rounded-full bg-blue-500 text-white flex items-center justify-center font-bold text-xl">
                    1
                  </div>
                </div>
                <div className="md:w-1/2 md:pl-16">
                  <ul className="space-y-2 text-gray-600">
                    <li className="flex items-start">
                      <div className="mt-1 mr-3 text-blue-600">
                        <Check size={16} className="text-blue-500" />
                      </div>
                      <span>Project goals and success metrics</span>
                    </li>
                    <li className="flex items-start">
                      <div className="mt-1 mr-3 text-blue-600">
                        <Check size={16} className="text-blue-500" />
                      </div>
                      <span>Budget and timeline constraints</span>
                    </li>
                    <li className="flex items-start">
                      <div className="mt-1 mr-3 text-blue-600">
                        <Check size={16} className="text-blue-500" />
                      </div>
                      <span>Technical feasibility assessment</span>
                    </li>
                  </ul>
                </div>
              </div>
              
              {/* Step 2 */}
              <div className="flex flex-col md:flex-row-reverse items-center">
                <div className="md:w-1/2 md:pl-16 mb-8 md:mb-0 text-center md:text-left">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Scope & Wireframes (Week 3-4)</h3>
                  <p className="text-justify md:text-left text-gray-600">
                    We define the core MVP features and user flows. This phase involves creating wireframes and a development roadmap that prioritizes the most critical functionality.
                  </p>
                </div>
                <div className="md:absolute md:left-1/2 md:transform md:-translate-x-1/2 z-10 bg-white rounded-full p-2 border-4 border-indigo-500 mb-8 md:mb-0">
                  <div className="w-12 h-12 rounded-full bg-indigo-500 text-white flex items-center justify-center font-bold text-xl">
                    2
                  </div>
                </div>
                <div className="md:w-1/2 md:pr-16 md:text-right">
                  <ul className="space-y-2 text-gray-600">
                    <li className="flex items-start md:flex-row-reverse">
                      <div className="mt-1 ml-0 mr-3 md:ml-3 md:mr-0 text-indigo-600">
                        <Check size={16} className="text-indigo-500" />
                      </div>
                      <span>Feature prioritization</span>
                    </li>
                    <li className="flex items-start md:flex-row-reverse">
                      <div className="mt-1 ml-0 mr-3 md:ml-3 md:mr-0 text-indigo-600">
                        <Check size={16} className="text-indigo-500" />
                      </div>
                      <span>User flow mapping</span>
                    </li>
                    <li className="flex items-start md:flex-row-reverse">
                      <div className="mt-1 ml-0 mr-3 md:ml-3 md:mr-0 text-indigo-600">
                        <Check size={16} className="text-indigo-500" />
                      </div>
                      <span>Wireframing and prototyping</span>
                    </li>
                  </ul>
                </div>
              </div>
              
              {/* Step 3 */}
              <div className="flex flex-col md:flex-row items-center">
                <div className="md:w-1/2 md:pr-16 mb-8 md:mb-0  text-center md:text-right">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Design & Development(Week 5-6)</h3>
                  <p className="text-justify md:text-right text-gray-600">
                    We build rapidly using agile sprints and weekly reviews. Our development process is transparent, with regular updates and checkpoints to ensure we're on the right track.
                  </p>
                </div>
                <div className="md:absolute md:left-1/2 md:transform md:-translate-x-1/2 z-10 bg-white rounded-full p-2 border-4 border-purple-500 mb-8 md:mb-0">
                  <div className="w-12 h-12 rounded-full bg-purple-500 text-white flex items-center justify-center font-bold text-xl">
                    3
                  </div>
                </div>
                <div className="md:w-1/2 md:pl-16">
                  <ul className="space-y-2 text-gray-600">
                    <li className="flex items-start">
                      <div className="mt-1 mr-3 text-purple-600">
                        <Check size={16} className="text-purple-500" />
                      </div>
                      <span>UI/UX design implementation</span>
                    </li>
                    <li className="flex items-start">
                      <div className="mt-1 mr-3 text-purple-600">
                        <Check size={16} className="text-purple-500" />
                      </div>
                      <span>Agile development sprints</span>
                    </li>
                    <li className="flex items-start">
                      <div className="mt-1 mr-3 text-purple-600">
                        <Check size={16} className="text-purple-500" />
                      </div>
                      <span>Weekly progress reviews</span>
                    </li>
                  </ul>
                </div>
              </div>
              
              {/* Step 4 */}
              <div className="flex flex-col md:flex-row-reverse items-center">
                <div className="md:w-1/2 md:pl-16 mb-8 md:mb-0 md:text-left">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Launch, Iterate & Scale (Week 7+)</h3>
                  <p className="text-gray-600">
                    We deploy your MVP, help you gather feedback, and make improvements based on real user data. This cycle of launch, learn, and refine is critical for MVP success.
                  </p>
                </div>
                <div className="md:absolute md:left-1/2 md:transform md:-translate-x-1/2 z-10 bg-white rounded-full p-2 border-4 border-green-500 mb-8 md:mb-0">
                  <div className="w-12 h-12 rounded-full bg-green-500 text-white flex items-center justify-center font-bold text-xl">
                    4
                  </div>
                </div>
                <div className="md:w-1/2 md:pr-16 md:text-right">
                  <ul className="space-y-2 text-gray-600">
                    <li className="flex items-start md:flex-row-reverse">
                      <div className="mt-1 ml-0 mr-3 md:ml-3 md:mr-0 text-green-600">
                        <Check size={16} className="text-green-500" />
                      </div>
                      <span>Deployment to staging/production</span>
                    </li>
                    <li className="flex items-start md:flex-row-reverse">
                      <div className="mt-1 ml-0 mr-3 md:ml-3 md:mr-0 text-green-600">
                        <Check size={16} className="text-green-500" />
                      </div>
                      <span>User feedback collection</span>
                    </li>
                    <li className="flex items-start md:flex-row-reverse">
                      <div className="mt-1 ml-0 mr-3 md:ml-3 md:mr-0 text-green-600">
                        <Check size={16} className="text-green-500" />
                      </div>
                      <span>Iterative improvements</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
)
}

export default Process;